import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider
} from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4, minHeight: 'calc(100vh - 200px)' }}>
        <Paper sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Gizlilik Politikası
          </Typography>
          <Divider sx={{ my: 2 }} />

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            1. Toplanan Bilgiler
          </Typography>
          <Typography variant="body1" paragraph>
            Anılar Bulutta olarak, hizmetlerimizi kullanırken sizden bazı kişisel bilgiler toplamaktayız. Bu bilgiler arasında adınız, e-posta adresiniz, profil fotoğrafınız ve Google hesabınızla ilişkili diğer bilgiler bulunabilir. Ayrıca, uygulamamıza yüklediğiniz fotoğraflar ve diğer içerikler de sunucularımızda saklanmaktadır.
          </Typography>
          <Typography variant="body1" paragraph>
            Google ile giriş yaptığınızda, ad, e-posta ve profil fotoğrafı bilgilerinize erişim sağlanır. Bu bilgiler yalnızca kullanıcı kimliğinizi doğrulamak ve hesabınızı oluşturmak için kullanılır.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            2. Kullandığımız Google API Yetkileri
          </Typography>
          <Typography variant="body1" paragraph>
            Uygulamamızda aşağıdaki Google API yetkilerini (scope) kullanmaktayız:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>
              <strong>https://www.googleapis.com/auth/userinfo.email</strong>: Kullanıcının e-posta adresini almak için kullanılır.
            </li>
            <li>
              <strong>https://www.googleapis.com/auth/userinfo.profile</strong>: Kullanıcının adını ve profil fotoğrafını almak için kullanılır.
            </li>
            <li>
              <strong>https://www.googleapis.com/auth/drive.file</strong>: Kullanıcının uygulama aracılığıyla yüklediği dosyaların, yalnızca kendi Google Drive hesabında uygulamaya ayrılmış bir klasöre kaydedilmesini sağlar. Uygulama, kullanıcının diğer dosyalarına erişemez veya değiştiremez.
            </li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. Bilgilerin Kullanımı
          </Typography>
          <Typography variant="body1" paragraph>
            Topladığımız bilgileri aşağıdaki amaçlar için kullanmaktayız:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Hesabınızı oluşturmak ve yönetmek</li>
            <li>Size hizmetlerimizi sunmak ve iyileştirmek</li>
            <li>Etkinliklerinizi ve yüklediğiniz içerikleri yönetmenizi sağlamak</li>
            <li>Güvenlik ve doğrulama işlemlerini gerçekleştirmek</li>
            <li>Yasal yükümlülüklerimizi yerine getirmek</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            4. Bilgi Paylaşımı
          </Typography>
          <Typography variant="body1" paragraph>
            Kişisel bilgilerinizi, açık izniniz olmadan üçüncü taraflarla paylaşmamaktayız. Ancak, aşağıdaki durumlarda bilgilerinizi paylaşabiliriz:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Yasal bir zorunluluk olduğunda (mahkeme kararı, yasal süreç vb.)</li>
            <li>Hizmetlerimizi sağlamak için çalıştığımız servis sağlayıcılarla (Google Drive gibi)</li>
            <li>Şirketimizin satılması veya birleşmesi durumunda</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. Veri Güvenliği
          </Typography>
          <Typography variant="body1" paragraph>
            Kişisel bilgilerinizin güvenliğini sağlamak için çeşitli teknik ve organizasyonel önlemler almaktayız. Ancak, internet üzerinden yapılan hiçbir veri iletiminin veya elektronik depolamanın %100 güvenli olmadığını belirtmek isteriz.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            6. Çerezler ve Benzer Teknolojiler
          </Typography>
          <Typography variant="body1" paragraph>
            Hizmetlerimizi iyileştirmek ve kullanıcı deneyimini geliştirmek için çerezler ve benzer teknolojiler kullanmaktayız. Bu teknolojiler, oturum bilgilerinizi hatırlamak ve site kullanımınızı analiz etmek için kullanılmaktadır.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            7. Kullanıcı Hakları
          </Typography>
          <Typography variant="body1" paragraph>
            Kişisel verilerinizle ilgili olarak aşağıdaki haklara sahipsiniz:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Verilerinize erişim talep etme</li>
            <li>Verilerinizin düzeltilmesini isteme</li>
            <li>Verilerinizin silinmesini talep etme</li>
            <li>Veri işlememize itiraz etme</li>
            <li>Verilerinizin taşınabilirliğini talep etme</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            8. Politika Değişiklikleri
          </Typography>
          <Typography variant="body1" paragraph>
            Bu gizlilik politikasını zaman zaman güncelleyebiliriz. Önemli değişiklikler olması durumunda, sizi e-posta yoluyla veya hizmetlerimiz üzerinden bilgilendireceğiz.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            9. İletişim
          </Typography>
          <Typography variant="body1" paragraph>
            Gizlilik politikamızla ilgili sorularınız veya endişeleriniz varsa, lütfen bizimle iletişime geçin: info@anilarbulutta.com
          </Typography>

          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
            Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Privacy;
